import { render, staticRenderFns } from "./goldExport.vue?vue&type=template&id=5e258cea&scoped=true&"
import script from "./goldExport.vue?vue&type=script&lang=js&"
export * from "./goldExport.vue?vue&type=script&lang=js&"
import style0 from "./goldExport.vue?vue&type=style&index=0&id=5e258cea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e258cea",
  null
  
)

export default component.exports